import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'
import Swiper from 'swiper/dist/js/swiper.min.js'

$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //滚动高度
  $('.section1 .bg-img b').css('transform','translateY('+ scroH / 4 +'px)')
});

$(document).ready(function(){
  let html = `<svg><rect></rect><rect></rect></svg>`
  $('.section3 .text .desc p').append(html)
})

$('.pro-list li .item-show').on('click',function(){
  let parents = $(this).closest('li')
  let album = parents.find('.item-album a')

  if( album.length > 0){
    album.eq(0).click()
  }
})

$('.section3 .text .desc p').hover(function(){
  let index = $(this).index()
  swiper.slideTo(index)
})

var swiper = new Swiper(".section3 .img .mySwiper", {
  speed: 800,
  watchOverflow: true,
  // loop: true,
  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  pagination: {
    el: ".section3 .img .swiper-pagination",
    clickable: true
  },
  on:{
    init: function(swiper){
      console.log(this)
      $('.section3 .text .desc p').eq(this.activeIndex).addClass('active')
    },
    slideChangeTransitionStart: function(){
      console.log(this)
      $('.section3 .text .desc p').eq(this.activeIndex).addClass('active').siblings().removeClass('active')
    },
  }
});
